import { css, useTheme } from '@emotion/react';
import { Link } from 'react-router-dom';

import { fontFamilies, fontSizes, spacing } from '../../theme/tokens';
import { ProfilePopover } from '../layout/profile-popover';

export function DashboardHeader() {
  const theme = useTheme();

  return (
    <header
      data-testid="dashboard-header"
      css={css`
        display: flex;
        align-items: center;
        height: 56px;
        padding: 0 ${spacing.md};
        background: ${theme.colors.sidebarBg};
        border-bottom: 1px solid ${theme.colors.border};
      `}
    >
      <Link
        to="/app/projects"
        css={css`
          display: flex;
          align-items: center;
          text-decoration: none;
        `}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="2" y="6" width="4" height="12" rx="1" fill={theme.colors.primary} />
          <rect
            x="8"
            y="3"
            width="4"
            height="18"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.7"
          />
          <rect
            x="14"
            y="8"
            width="4"
            height="8"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.5"
          />
          <rect
            x="20"
            y="5"
            width="4"
            height="14"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.3"
          />
        </svg>
        <span
          css={css`
            margin-left: ${spacing.sm};
            font-family: ${fontFamilies.display};
            font-size: ${fontSizes.xl};
            font-weight: 700;
            color: ${theme.colors.text};
          `}
        >
          Sonematic
        </span>
      </Link>
      <div
        css={css`
          flex: 1;
        `}
      />
      <ProfilePopover collapsed={false} />
    </header>
  );
}
